'use client';

import React from 'react';
import { ReactSVG } from 'react-svg';
import { IconSaxIcon } from './design-system/atoms/icon';

interface FileUploadProps {
  attachments: File[];
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleRemoveAttachment: (fileName: string) => void;
}

export default function FileUpload({
  attachments,
  handleFileChange,
  handleRemoveAttachment,
}: FileUploadProps) {
  return (
    <div className="w-full">
      <div className="mb-1 flex items-center justify-between">
        <h3 className="text-[12px] font-medium text-N900">Attachments</h3>
        <span className="text-[12px] text-E100">jpg, jpeg, png, pdf formats, up to 2 MB</span>
      </div>

      <label
        htmlFor="attachments-upload"
        style={{ border: '1px solid #E9ECEF' }}
        className="flex cursor-pointer items-center gap-3 rounded-[10px] px-3 py-2 pl-1 transition-colors hover:bg-gray-100/50"
      >
        <ReactSVG
          src={require('@assets/icons/other/upload-cloud.svg')}
          className="text-N900"
          beforeInjection={(svg) => {
            svg.setAttribute('width', '24');
            svg.setAttribute('height', '24');
          }}
        />
        <span className="text-[14px] font-medium text-N900">Select files</span>
      </label>

      <input
        id="attachments-upload"
        type="file"
        multiple
        onChange={handleFileChange}
        className="hidden"
        accept=".jpg,.jpeg,.png,.pdf"
      />

      {attachments.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-4">
          {attachments.map((file, idx) => (
            <div
              key={file.name || idx}
              style={{ width: '72px', height: '72px', borderRadius: '12px' }}
              className="rounded-2xl relative flex items-center justify-center overflow-hidden border border-gray-200 bg-white shadow-lg"
            >
              {file.type?.match(/^image\//) ? (
                <img
                  src={URL.createObjectURL(file) || '/placeholder.svg'}
                  alt={file.name}
                  className="h-[100px] w-[100px] object-contain"
                />
              ) : (
                <span className="break-all p-2 text-center text-xs text-gray-400">{file.name}</span>
              )}
              <button
                type="button"
                className="absolute right-[-3%] top-[-.5px] z-10 flex items-center justify-center rounded-full border border-gray-200 bg-white p-1 shadow-md hover:bg-gray-50"
                onClick={() => handleRemoveAttachment(file.name)}
                style={{ width: '28px', height: '28px' }}
              >
                <IconSaxIcon
                  name="trash"
                  size={16}
                  strokeColor="#E5422F"
                  className="cursor-pointer"
                />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
